function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["formTitle", "showBranding", "showName", "showEmail", "isNameRequired", "isEmailRequired", "colorScheme", "defaultName", "defaultEmail", "onClosed", "onCancel", "onSubmit"],
    _excluded2 = ["shouldCreateActor"];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { GLOBAL_OBJ, getLocationHref, logger, isBrowser } from '@sentry/utils';
import { prepareEvent, getIsolationScope, getClient, withScope, createEventEnvelope, getCurrentScope } from '@sentry/core'; // exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages

var WINDOW = GLOBAL_OBJ;
var LIGHT_BACKGROUND = '#ffffff';
var INHERIT = 'inherit';
var SUBMIT_COLOR = 'rgba(108, 95, 199, 1)';
var LIGHT_THEME = {
  fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
  fontSize: '14px',
  background: LIGHT_BACKGROUND,
  backgroundHover: '#f6f6f7',
  foreground: '#2b2233',
  border: '1.5px solid rgba(41, 35, 47, 0.13)',
  borderRadius: '12px',
  boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
  success: '#268d75',
  error: '#df3338',
  submitBackground: 'rgba(88, 74, 192, 1)',
  submitBackgroundHover: SUBMIT_COLOR,
  submitBorder: SUBMIT_COLOR,
  submitOutlineFocus: '#29232f',
  submitForeground: LIGHT_BACKGROUND,
  submitForegroundHover: LIGHT_BACKGROUND,
  cancelBackground: 'transparent',
  cancelBackgroundHover: 'var(--background-hover)',
  cancelBorder: 'var(--border)',
  cancelOutlineFocus: 'var(--input-outline-focus)',
  cancelForeground: 'var(--foreground)',
  cancelForegroundHover: 'var(--foreground)',
  inputBackground: INHERIT,
  inputForeground: INHERIT,
  inputBorder: 'var(--border)',
  inputOutlineFocus: SUBMIT_COLOR,
  formBorderRadius: '20px',
  formContentBorderRadius: '6px'
};
var DEFAULT_THEME = {
  light: LIGHT_THEME,
  dark: _objectSpread(_objectSpread({}, LIGHT_THEME), {}, {
    background: '#29232f',
    backgroundHover: '#352f3b',
    foreground: '#ebe6ef',
    border: '1.5px solid rgba(235, 230, 239, 0.15)',
    success: '#2da98c',
    error: '#f55459'
  })
};
var ACTOR_LABEL = 'Report a Bug';
var CANCEL_BUTTON_LABEL = 'Cancel';
var SUBMIT_BUTTON_LABEL = 'Send Bug Report';
var FORM_TITLE = 'Report a Bug';
var EMAIL_PLACEHOLDER = 'your.email@example.org';
var EMAIL_LABEL = 'Email';
var MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
var MESSAGE_LABEL = 'Description';
var NAME_PLACEHOLDER = 'Your Name';
var NAME_LABEL = 'Name';
var SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
var FEEDBACK_WIDGET_SOURCE = 'widget';
var FEEDBACK_API_SOURCE = 'api';
/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */

function prepareFeedbackEvent(_x) {
  return _prepareFeedbackEvent.apply(this, arguments);
}
/**
 * Send feedback using transport
 */


function _prepareFeedbackEvent() {
  _prepareFeedbackEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
    var client, scope, event, eventHint, preparedEvent;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref.client, scope = _ref.scope, event = _ref.event;
            eventHint = {};

            if (client.emit) {
              client.emit('preprocessEvent', event, eventHint);
            }

            _context2.next = 5;
            return prepareEvent(client.getOptions(), event, eventHint, scope, client, getIsolationScope());

          case 5:
            preparedEvent = _context2.sent;

            if (!(preparedEvent === null)) {
              _context2.next = 9;
              break;
            }

            // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
            client.recordDroppedEvent('event_processor', 'feedback', event);
            return _context2.abrupt("return", null);

          case 9:
            // This normally happens in browser client "_prepareEvent"
            // but since we do not use this private method from the client, but rather the plain import
            // we need to do this manually.
            preparedEvent.platform = preparedEvent.platform || 'javascript';
            return _context2.abrupt("return", preparedEvent);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _prepareFeedbackEvent.apply(this, arguments);
}

function sendFeedbackRequest(_x2) {
  return _sendFeedbackRequest.apply(this, arguments);
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */

/**
 * Public API to send a Feedback item to Sentry
 */


function _sendFeedbackRequest() {
  _sendFeedbackRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref2) {
    var _ref2$feedback,
        message,
        email,
        name,
        source,
        url,
        _ref19,
        _ref19$includeReplay,
        includeReplay,
        client,
        transport,
        dsn,
        baseEvent,
        _args4 = arguments;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref2$feedback = _ref2.feedback, message = _ref2$feedback.message, email = _ref2$feedback.email, name = _ref2$feedback.name, source = _ref2$feedback.source, url = _ref2$feedback.url;
            _ref19 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, _ref19$includeReplay = _ref19.includeReplay, includeReplay = _ref19$includeReplay === void 0 ? true : _ref19$includeReplay;
            client = getClient();
            transport = client && client.getTransport();
            dsn = client && client.getDsn();

            if (!(!client || !transport || !dsn)) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return");

          case 7:
            baseEvent = {
              contexts: {
                feedback: {
                  contact_email: email,
                  name: name,
                  message: message,
                  url: url,
                  source: source
                }
              },
              type: 'feedback'
            };
            return _context4.abrupt("return", withScope( /*#__PURE__*/function () {
              var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(scope) {
                var feedbackEvent, envelope, response, error;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // No use for breadcrumbs in feedback
                        scope.clearBreadcrumbs();

                        if ([FEEDBACK_API_SOURCE, FEEDBACK_WIDGET_SOURCE].includes(String(source))) {
                          scope.setLevel('info');
                        }

                        _context3.next = 4;
                        return prepareFeedbackEvent({
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          scope: scope,
                          client: client,
                          event: baseEvent
                        });

                      case 4:
                        feedbackEvent = _context3.sent;

                        if (feedbackEvent) {
                          _context3.next = 7;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 7:
                        if (client.emit) {
                          client.emit('beforeSendFeedback', feedbackEvent, {
                            includeReplay: Boolean(includeReplay)
                          });
                        }

                        envelope = createEventEnvelope(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
                        _context3.prev = 9;
                        _context3.next = 12;
                        return transport.send(envelope);

                      case 12:
                        response = _context3.sent;
                        _context3.next = 20;
                        break;

                      case 15:
                        _context3.prev = 15;
                        _context3.t0 = _context3["catch"](9);
                        error = new Error('Unable to send Feedback');

                        try {
                          // In case browsers don't allow this property to be writable
                          // @ts-expect-error This needs lib es2022 and newer
                          error.cause = _context3.t0;
                        } catch (e) {// nothing to do
                        }

                        throw error;

                      case 20:
                        if (response) {
                          _context3.next = 22;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 22:
                        if (!(typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300))) {
                          _context3.next = 24;
                          break;
                        }

                        throw new Error('Unable to send Feedback');

                      case 24:
                        return _context3.abrupt("return", response);

                      case 25:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[9, 15]]);
              }));

              return function (_x7) {
                return _ref20.apply(this, arguments);
              };
            }()));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _sendFeedbackRequest.apply(this, arguments);
}

function sendFeedback(_ref3) {
  var name = _ref3.name,
      email = _ref3.email,
      message = _ref3.message,
      _ref3$source = _ref3.source,
      source = _ref3$source === void 0 ? FEEDBACK_API_SOURCE : _ref3$source,
      _ref3$url = _ref3.url,
      url = _ref3$url === void 0 ? getLocationHref() : _ref3$url;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!message) {
    throw new Error('Unable to submit feedback with empty message');
  }

  return sendFeedbackRequest({
    feedback: {
      name: name,
      email: email,
      message: message,
      url: url,
      source: source
    }
  }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */


var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */

function mergeOptions(defaultOptions, optionOverrides) {
  return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), optionOverrides), {}, {
    themeDark: _objectSpread(_objectSpread({}, defaultOptions.themeDark), optionOverrides.themeDark),
    themeLight: _objectSpread(_objectSpread({}, defaultOptions.themeLight), optionOverrides.themeLight)
  });
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */


function createActorStyles(d) {
  var style = d.createElement('style');
  style.textContent = "\n.widget__actor {\n  line-height: 25px;\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px 16px;\n  text-decoration: none;\n  z-index: 9000;\n\n  color: var(--foreground);\n  background-color: var(--background);\n  border: var(--border);\n  box-shadow: var(--box-shadow);\n  opacity: 1;\n  transition: opacity 0.1s ease-in-out;\n}\n\n.widget__actor:hover {\n  background-color: var(--background-hover);\n}\n\n.widget__actor svg {\n  width: 16px;\n  height: 16px;\n}\n\n.widget__actor--hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.widget__actor__text {\n}\n\n.feedback-icon path {\n  fill: var(--foreground);\n}\n";
  return style;
}
/**
 * Creates <style> element for widget dialog
 */


function createDialogStyles(d) {
  var style = d.createElement('style');
  style.textContent = "\n.dialog {\n  line-height: 25px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border: none;\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.dialog:not([open]) {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.dialog:not([open]) .dialog__content {\n  transform: translate(0, -16px) scale(0.98);\n}\n\n.dialog__content {\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n\n  border: var(--border);\n  border-radius: var(--form-border-radius);\n  background-color: var(--background);\n  color: var(--foreground);\n\n  width: 320px;\n  max-width: 100%;\n  max-height: calc(100% - 2rem);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--box-shadow);\n  transition: transform 0.2s ease-in-out;\n  transform: translate(0, 0) scale(1);\n}\n\n.dialog__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 24px 24px 0 24px;\n  margin: 0;\n  margin-bottom: 16px;\n}\n\n.brand-link {\n  display: inline-flex;\n}\n\n.error {\n  color: var(--error);\n  margin-bottom: 16px;\n}\n\n.form {\n  display: grid;\n  overflow: auto;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 24px 24px;\n}\n\n.form__error-container {\n  color: var(--error);\n}\n\n.form__error-container--hidden {\n  display: none;\n}\n\n.form__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0px;\n}\n\n.form__label__text {\n  display: grid;\n  gap: 4px;\n  align-items: center;\n  grid-auto-flow: column;\n  grid-auto-columns: max-content;\n}\n\n.form__label__text--required {\n  font-size: 0.85em;\n}\n\n.form__input {\n  font-family: inherit;\n  line-height: inherit;\n  background-color: var(--input-background);\n  box-sizing: border-box;\n  border: var(--input-border);\n  border-radius: var(--form-content-border-radius);\n  color: var(--input-foreground);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 6px 12px;\n}\n\n.form__input:focus-visible {\n  outline: 1px auto var(--input-outline-focus);\n}\n\n.form__input--textarea {\n  font-family: inherit;\n  resize: vertical;\n}\n\n.btn-group {\n  display: grid;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.btn {\n  line-height: inherit;\n  border: var(--cancel-border);\n  border-radius: var(--form-content-border-radius);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 16px;\n}\n.btn[disabled] {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.btn--primary {\n  background-color: var(--submit-background);\n  border-color: var(--submit-border);\n  color: var(--submit-foreground);\n}\n.btn--primary:hover {\n  background-color: var(--submit-background-hover);\n  color: var(--submit-foreground-hover);\n}\n.btn--primary:focus-visible {\n  outline: 1px auto var(--submit-outline-focus);\n}\n\n.btn--default {\n  background-color: var(--cancel-background);\n  color: var(--cancel-foreground);\n  font-weight: 500;\n}\n.btn--default:hover {\n  background-color: var(--cancel-background-hover);\n  color: var(--cancel-foreground-hover);\n}\n.btn--default:focus-visible {\n  outline: 1px auto var(--cancel-outline-focus);\n}\n\n.success-message {\n  background-color: var(--background);\n  border: var(--border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  font-weight: 600;\n  color: var(--success);\n  padding: 12px 24px;\n  line-height: 25px;\n  display: grid;\n  align-items: center;\n  grid-auto-flow: column;\n  gap: 6px;\n  cursor: default;\n}\n\n.success-icon path {\n  fill: var(--success);\n}\n";
  return style;
}

function getThemedCssVariables(theme) {
  return "\n  --background: ".concat(theme.background, ";\n  --background-hover: ").concat(theme.backgroundHover, ";\n  --foreground: ").concat(theme.foreground, ";\n  --error: ").concat(theme.error, ";\n  --success: ").concat(theme.success, ";\n  --border: ").concat(theme.border, ";\n  --border-radius: ").concat(theme.borderRadius, ";\n  --box-shadow: ").concat(theme.boxShadow, ";\n\n  --submit-background: ").concat(theme.submitBackground, ";\n  --submit-background-hover: ").concat(theme.submitBackgroundHover, ";\n  --submit-border: ").concat(theme.submitBorder, ";\n  --submit-outline-focus: ").concat(theme.submitOutlineFocus, ";\n  --submit-foreground: ").concat(theme.submitForeground, ";\n  --submit-foreground-hover: ").concat(theme.submitForegroundHover, ";\n\n  --cancel-background: ").concat(theme.cancelBackground, ";\n  --cancel-background-hover: ").concat(theme.cancelBackgroundHover, ";\n  --cancel-border: ").concat(theme.cancelBorder, ";\n  --cancel-outline-focus: ").concat(theme.cancelOutlineFocus, ";\n  --cancel-foreground: ").concat(theme.cancelForeground, ";\n  --cancel-foreground-hover: ").concat(theme.cancelForegroundHover, ";\n\n  --input-background: ").concat(theme.inputBackground, ";\n  --input-foreground: ").concat(theme.inputForeground, ";\n  --input-border: ").concat(theme.inputBorder, ";\n  --input-outline-focus: ").concat(theme.inputOutlineFocus, ";\n\n  --form-border-radius: ").concat(theme.formBorderRadius, ";\n  --form-content-border-radius: ").concat(theme.formContentBorderRadius, ";\n  ");
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */


function createMainStyles(d, colorScheme, themes) {
  var style = d.createElement('style');
  style.textContent = "\n:host {\n  --bottom: 1rem;\n  --right: 1rem;\n  --top: auto;\n  --left: auto;\n  --z-index: 100000;\n  --font-family: ".concat(themes.light.fontFamily, ";\n  --font-size: ").concat(themes.light.fontSize, ";\n\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n  z-index: var(--z-index);\n\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n\n  ").concat(getThemedCssVariables(colorScheme === 'dark' ? themes.dark : themes.light), "\n}\n\n").concat(colorScheme === 'system' ? "\n@media (prefers-color-scheme: dark) {\n  :host {\n    ".concat(getThemedCssVariables(themes.dark), "\n  }\n}") : '', "\n}");
  return style;
}
/**
 * Creates shadow host
 */


function createShadowHost(_ref4) {
  var id = _ref4.id,
      colorScheme = _ref4.colorScheme,
      themeDark = _ref4.themeDark,
      themeLight = _ref4.themeLight;

  try {
    var _doc = WINDOW.document; // Create the host

    var host = _doc.createElement('div');

    host.id = id; // Create the shadow root

    var shadow = host.attachShadow({
      mode: 'open'
    });
    shadow.appendChild(createMainStyles(_doc, colorScheme, {
      dark: themeDark,
      light: themeLight
    }));
    shadow.appendChild(createDialogStyles(_doc));
    return {
      shadow: shadow,
      host: host
    };
  } catch (e) {
    // Shadow DOM probably not supported
    logger.warn('[Feedback] Browser does not support shadow DOM API');
    throw new Error('Browser does not support shadow DOM API.');
  }
}
/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */


function handleFeedbackSubmit(_x3, _x4, _x5) {
  return _handleFeedbackSubmit2.apply(this, arguments);
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */


function _handleFeedbackSubmit2() {
  _handleFeedbackSubmit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dialog, feedback, options) {
    var showFetchError, resp;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (dialog) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            showFetchError = function showFetchError() {
              if (!dialog) {
                return;
              }

              dialog.showError('There was a problem submitting feedback, please wait and try again.');
            };

            dialog.hideError();
            _context5.prev = 4;
            _context5.next = 7;
            return sendFeedback(_objectSpread(_objectSpread({}, feedback), {}, {
              source: FEEDBACK_WIDGET_SOURCE
            }), options);

          case 7:
            resp = _context5.sent;
            return _context5.abrupt("return", resp);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](4);
            DEBUG_BUILD && logger.error(_context5.t0);
            showFetchError();

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 11]]);
  }));
  return _handleFeedbackSubmit2.apply(this, arguments);
}

function setAttributesNS(el, attributes) {
  Object.entries(attributes).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    el.setAttributeNS(null, key, val);
  });
  return el;
}

var SIZE = 20;
var XMLNS$2 = 'http://www.w3.org/2000/svg';
/**
 * Feedback Icon
 */

function Icon() {
  var _setAttributesNS;

  var createElementNS = function createElementNS(tagName) {
    return WINDOW.document.createElementNS(XMLNS$2, tagName);
  };

  var svg = setAttributesNS(createElementNS('svg'), {
    class: 'feedback-icon',
    width: "".concat(SIZE),
    height: "".concat(SIZE),
    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
    fill: 'none'
  });
  var g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_80)'
  });
  var path = setAttributesNS(createElementNS('path'), (_setAttributesNS = {}, _defineProperty(_setAttributesNS, 'fill-rule', 'evenodd'), _defineProperty(_setAttributesNS, 'clip-rule', 'evenodd'), _defineProperty(_setAttributesNS, "d", 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'), _setAttributesNS));
  svg.appendChild(g).appendChild(path);
  var speakerDefs = createElementNS('defs');
  var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_80'
  });
  var speakerRect = setAttributesNS(createElementNS('rect'), {
    width: "".concat(SIZE),
    height: "".concat(SIZE),
    fill: 'white'
  });
  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);
  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
  return {
    get el() {
      return svg;
    }

  };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */


function createElement(tagName, attributes) {
  var doc = WINDOW.document;
  var element = doc.createElement(tagName);

  if (attributes) {
    Object.entries(attributes).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          attribute = _ref8[0],
          attributeValue = _ref8[1];

      if (attribute === 'className' && typeof attributeValue === 'string') {
        // JSX does not allow class as a valid name
        element.setAttribute('class', attributeValue);
      } else if (typeof attributeValue === 'boolean' && attributeValue) {
        element.setAttribute(attribute, '');
      } else if (typeof attributeValue === 'string') {
        element.setAttribute(attribute, attributeValue);
      } else if (attribute.startsWith('on') && typeof attributeValue === 'function') {
        element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
      }
    });
  }

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  for (var _i2 = 0, _children = children; _i2 < _children.length; _i2++) {
    var child = _children[_i2];
    appendChild(element, child);
  }

  return element;
}

function appendChild(parent, child) {
  var doc = WINDOW.document;

  if (typeof child === 'undefined' || child === null) {
    return;
  }

  if (Array.isArray(child)) {
    var _iterator = _createForOfIteratorHelper(child),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        appendChild(parent, value);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (child === false) ;else if (typeof child === 'string') {
    parent.appendChild(doc.createTextNode(child));
  } else if (child instanceof Node) {
    parent.appendChild(child);
  } else {
    parent.appendChild(doc.createTextNode(String(child)));
  }
}
/**
 *
 */


function Actor(_ref9) {
  var _createElement;

  var buttonLabel = _ref9.buttonLabel,
      onClick = _ref9.onClick;

  function _handleClick(e) {
    onClick && onClick(e);
  }

  var el = createElement('button', (_createElement = {
    type: 'button',
    className: 'widget__actor'
  }, _defineProperty(_createElement, 'aria-label', buttonLabel), _defineProperty(_createElement, 'aria-hidden', 'false'), _createElement), Icon().el, buttonLabel ? createElement('span', {
    className: 'widget__actor__text'
  }, buttonLabel) : null);
  el.addEventListener('click', _handleClick);
  return {
    get el() {
      return el;
    },

    show: function show() {
      el.classList.remove('widget__actor--hidden');
      el.setAttribute('aria-hidden', 'false');
    },
    hide: function hide() {
      el.classList.add('widget__actor--hidden');
      el.setAttribute('aria-hidden', 'true');
    }
  };
}
/**
 *
 */


function SubmitButton(_ref10) {
  var label = _ref10.label;
  var el = createElement('button', _defineProperty({
    type: 'submit',
    className: 'btn btn--primary'
  }, 'aria-label', label), label);
  return {
    el: el
  };
}

function retrieveStringValue(formData, key) {
  var value = formData.get(key);

  if (typeof value === 'string') {
    return value.trim();
  }

  return '';
}
/**
 * Creates the form element
 */


function Form(_ref11) {
  var _createElement4, _createElement5, _createElement6;

  var nameLabel = _ref11.nameLabel,
      namePlaceholder = _ref11.namePlaceholder,
      emailLabel = _ref11.emailLabel,
      emailPlaceholder = _ref11.emailPlaceholder,
      messageLabel = _ref11.messageLabel,
      messagePlaceholder = _ref11.messagePlaceholder,
      cancelButtonLabel = _ref11.cancelButtonLabel,
      submitButtonLabel = _ref11.submitButtonLabel,
      showName = _ref11.showName,
      showEmail = _ref11.showEmail,
      isNameRequired = _ref11.isNameRequired,
      isEmailRequired = _ref11.isEmailRequired,
      defaultName = _ref11.defaultName,
      defaultEmail = _ref11.defaultEmail,
      onCancel = _ref11.onCancel,
      onSubmit = _ref11.onSubmit;

  var _SubmitButton = SubmitButton({
    label: submitButtonLabel
  }),
      submitEl = _SubmitButton.el;

  function handleSubmit(e) {
    e.preventDefault();

    if (!(e.target instanceof HTMLFormElement)) {
      return;
    }

    try {
      if (onSubmit) {
        var formData = new FormData(e.target);
        var feedback = {
          name: retrieveStringValue(formData, 'name'),
          email: retrieveStringValue(formData, 'email'),
          message: retrieveStringValue(formData, 'message')
        };
        onSubmit(feedback);
      }
    } catch (e2) {// pass
    }
  }

  var errorEl = createElement('div', _defineProperty({
    className: 'form__error-container form__error-container--hidden'
  }, 'aria-hidden', 'true'));

  function showError(message) {
    errorEl.textContent = message;
    errorEl.classList.remove('form__error-container--hidden');
    errorEl.setAttribute('aria-hidden', 'false');
  }

  function hideError() {
    errorEl.textContent = '';
    errorEl.classList.add('form__error-container--hidden');
    errorEl.setAttribute('aria-hidden', 'true');
  }

  var nameEl = createElement('input', (_createElement4 = {
    id: 'name',
    type: showName ? 'text' : 'hidden'
  }, _defineProperty(_createElement4, 'aria-hidden', showName ? 'false' : 'true'), _defineProperty(_createElement4, "name", 'name'), _defineProperty(_createElement4, "required", isNameRequired), _defineProperty(_createElement4, "className", 'form__input'), _defineProperty(_createElement4, "placeholder", namePlaceholder), _defineProperty(_createElement4, "value", defaultName), _createElement4));
  var emailEl = createElement('input', (_createElement5 = {
    id: 'email',
    type: showEmail ? 'text' : 'hidden'
  }, _defineProperty(_createElement5, 'aria-hidden', showEmail ? 'false' : 'true'), _defineProperty(_createElement5, "name", 'email'), _defineProperty(_createElement5, "required", isEmailRequired), _defineProperty(_createElement5, "className", 'form__input'), _defineProperty(_createElement5, "placeholder", emailPlaceholder), _defineProperty(_createElement5, "value", defaultEmail), _createElement5));
  var messageEl = createElement('textarea', {
    id: 'message',
    autoFocus: 'true',
    rows: '5',
    name: 'message',
    required: true,
    className: 'form__input form__input--textarea',
    placeholder: messagePlaceholder
  });
  var cancelEl = createElement('button', (_createElement6 = {
    type: 'button',
    className: 'btn btn--default'
  }, _defineProperty(_createElement6, 'aria-label', cancelButtonLabel), _defineProperty(_createElement6, "onClick", function onClick(e) {
    onCancel && onCancel(e);
  }), _createElement6), cancelButtonLabel);
  var formEl = createElement('form', {
    className: 'form',
    onSubmit: handleSubmit
  }, [errorEl, showName && createElement('label', {
    htmlFor: 'name',
    className: 'form__label'
  }, [createElement('span', {
    className: 'form__label__text'
  }, nameLabel, isNameRequired && createElement('span', {
    className: 'form__label__text--required'
  }, ' (required)')), nameEl]), !showName && nameEl, showEmail && createElement('label', {
    htmlFor: 'email',
    className: 'form__label'
  }, [createElement('span', {
    className: 'form__label__text'
  }, emailLabel, isEmailRequired && createElement('span', {
    className: 'form__label__text--required'
  }, ' (required)')), emailEl]), !showEmail && emailEl, createElement('label', {
    htmlFor: 'message',
    className: 'form__label'
  }, [createElement('span', {
    className: 'form__label__text'
  }, messageLabel, createElement('span', {
    className: 'form__label__text--required'
  }, ' (required)')), messageEl]), createElement('div', {
    className: 'btn-group'
  }, [submitEl, cancelEl])]);
  return {
    get el() {
      return formEl;
    },

    showError: showError,
    hideError: hideError
  };
}

var XMLNS$1 = 'http://www.w3.org/2000/svg';
/**
 * Sentry Logo
 */

function Logo(_ref12) {
  var colorScheme = _ref12.colorScheme;

  var createElementNS = function createElementNS(tagName) {
    return WINDOW.document.createElementNS(XMLNS$1, tagName);
  };

  var svg = setAttributesNS(createElementNS('svg'), {
    class: 'sentry-logo',
    width: '32',
    height: '30',
    viewBox: '0 0 72 66',
    fill: 'none'
  });
  var path = setAttributesNS(createElementNS('path'), {
    transform: 'translate(11, 11)',
    d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
  });
  svg.append(path);
  var defs = createElementNS('defs');
  var style = createElementNS('style');
  style.textContent = "\n    path {\n      fill: ".concat(colorScheme === 'dark' ? '#fff' : '#362d59', ";\n    }");

  if (colorScheme === 'system') {
    style.textContent += "\n    @media (prefers-color-scheme: dark) {\n      path: {\n        fill: '#fff';\n      }\n    }\n    ";
  }

  defs.append(style);
  svg.append(defs);
  return {
    get el() {
      return svg;
    }

  };
}
/**
 * Feedback dialog component that has the form
 */


function Dialog(_ref13) {
  var formTitle = _ref13.formTitle,
      showBranding = _ref13.showBranding,
      showName = _ref13.showName,
      showEmail = _ref13.showEmail,
      isNameRequired = _ref13.isNameRequired,
      isEmailRequired = _ref13.isEmailRequired,
      colorScheme = _ref13.colorScheme,
      defaultName = _ref13.defaultName,
      defaultEmail = _ref13.defaultEmail,
      onClosed = _ref13.onClosed,
      onCancel = _ref13.onCancel,
      onSubmit = _ref13.onSubmit,
      textLabels = _objectWithoutProperties(_ref13, _excluded);

  var el = null;
  /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */

  function handleDialogClick() {
    close(); // Only this should trigger `onClose`, we don't want the `close()` method to
    // trigger it, otherwise it can cause cycles.

    onClosed && onClosed();
  }
  /**
   * Close the dialog
   */


  function close() {
    if (el) {
      el.open = false;
    }
  }
  /**
   * Opens the dialog
   */


  function open() {
    if (el) {
      el.open = true;
    }
  }
  /**
   * Check if dialog is currently opened
   */


  function checkIsOpen() {
    return el && el.open === true || false;
  }

  var _Form = Form(_objectSpread({
    showEmail: showEmail,
    showName: showName,
    isEmailRequired: isEmailRequired,
    isNameRequired: isNameRequired,
    defaultName: defaultName,
    defaultEmail: defaultEmail,
    onSubmit: onSubmit,
    onCancel: onCancel
  }, textLabels)),
      formEl = _Form.el,
      showError = _Form.showError,
      hideError = _Form.hideError;

  el = createElement('dialog', {
    className: 'dialog',
    open: true,
    onClick: handleDialogClick
  }, createElement('div', {
    className: 'dialog__content',
    onClick: function onClick(e) {
      // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
      e.stopPropagation();
    }
  }, createElement('h2', {
    className: 'dialog__header'
  }, formTitle, showBranding && createElement('a', {
    className: 'brand-link',
    target: '_blank',
    href: 'https://sentry.io/welcome/',
    title: 'Powered by Sentry',
    rel: 'noopener noreferrer'
  }, Logo({
    colorScheme: colorScheme
  }).el)), formEl));
  return {
    get el() {
      return el;
    },

    showError: showError,
    hideError: hideError,
    open: open,
    close: close,
    checkIsOpen: checkIsOpen
  };
}

var WIDTH = 16;
var HEIGHT = 17;
var XMLNS = 'http://www.w3.org/2000/svg';
/**
 * Success Icon (checkmark)
 */

function SuccessIcon() {
  var _setAttributesNS2;

  var createElementNS = function createElementNS(tagName) {
    return WINDOW.document.createElementNS(XMLNS, tagName);
  };

  var svg = setAttributesNS(createElementNS('svg'), {
    class: 'success-icon',
    width: "".concat(WIDTH),
    height: "".concat(HEIGHT),
    viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT),
    fill: 'none'
  });
  var g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_156)'
  });
  var path2 = setAttributesNS(createElementNS('path'), (_setAttributesNS2 = {}, _defineProperty(_setAttributesNS2, 'fill-rule', 'evenodd'), _defineProperty(_setAttributesNS2, 'clip-rule', 'evenodd'), _defineProperty(_setAttributesNS2, "d", 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'), _setAttributesNS2));
  var path = setAttributesNS(createElementNS('path'), {
    d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
  });
  svg.appendChild(g).append(path, path2);
  var speakerDefs = createElementNS('defs');
  var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_156'
  });
  var speakerRect = setAttributesNS(createElementNS('rect'), {
    width: "".concat(WIDTH),
    height: "".concat(WIDTH),
    fill: 'white',
    transform: 'translate(0 0.5)'
  });
  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);
  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
  return {
    get el() {
      return svg;
    }

  };
}
/**
 * Feedback dialog component that has the form
 */


function SuccessMessage(_ref14) {
  var message = _ref14.message,
      onRemove = _ref14.onRemove;

  function remove() {
    if (!el) {
      return;
    }

    el.remove();
    onRemove && onRemove();
  }

  var el = createElement('div', {
    className: 'success-message',
    onClick: remove
  }, SuccessIcon().el, message);
  return {
    el: el,
    remove: remove
  };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */


function createWidget(_ref15) {
  var shadow = _ref15.shadow,
      _ref15$options = _ref15.options,
      _ref15$options$should = _ref15$options.shouldCreateActor,
      shouldCreateActor = _ref15$options$should === void 0 ? true : _ref15$options$should,
      options = _objectWithoutProperties(_ref15$options, _excluded2),
      attachTo = _ref15.attachTo;

  var actor;
  var dialog;
  var isDialogOpen = false;
  /**
   * Show the success message for 5 seconds
   */

  function showSuccessMessage() {
    if (!shadow) {
      return;
    }

    try {
      var success = SuccessMessage({
        message: options.successMessageText,
        onRemove: function onRemove() {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          showActor();
        }
      });

      if (!success.el) {
        throw new Error('Unable to show success message');
      }

      shadow.appendChild(success.el);
      var timeoutId = setTimeout(function () {
        if (success) {
          success.remove();
        }
      }, 5000);
    } catch (err) {
      // TODO: error handling
      logger.error(err);
    }
  }
  /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */


  function _handleFeedbackSubmit(_x6) {
    return _handleFeedbackSubmit3.apply(this, arguments);
  }
  /**
   * Internal handler when dialog is opened
   */


  function _handleFeedbackSubmit3() {
    _handleFeedbackSubmit3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(feedback) {
      var emptyField, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (dialog) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              // Simple validation for now, just check for non-empty required fields
              emptyField = [];

              if (options.isNameRequired && !feedback.name) {
                emptyField.push(options.nameLabel);
              }

              if (options.isEmailRequired && !feedback.email) {
                emptyField.push(options.emailLabel);
              }

              if (!feedback.message) {
                emptyField.push(options.messageLabel);
              }

              if (!(emptyField.length > 0)) {
                _context.next = 9;
                break;
              }

              dialog.showError("Please enter in the following required fields: ".concat(emptyField.join(', ')));
              return _context.abrupt("return");

            case 9:
              _context.next = 11;
              return handleFeedbackSubmit(dialog, feedback);

            case 11:
              result = _context.sent;

              if (result) {
                _context.next = 15;
                break;
              }

              if (options.onSubmitError) {
                options.onSubmitError();
              }

              return _context.abrupt("return");

            case 15:
              // Success
              removeDialog();
              showSuccessMessage();

              if (options.onSubmitSuccess) {
                options.onSubmitSuccess();
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleFeedbackSubmit3.apply(this, arguments);
  }

  function handleOpenDialog() {
    // Flush replay if integration exists
    var client = getClient();
    var replay = client && client.getIntegrationByName && client.getIntegrationByName('Replay');

    if (!replay) {
      return;
    }

    replay.flush().catch(function (err) {
      DEBUG_BUILD && logger.error(err);
    });
  }
  /**
   * Displays the default actor
   */


  function showActor() {
    actor && actor.show();
  }
  /**
   * Hides the default actor
   */


  function hideActor() {
    actor && actor.hide();
  }
  /**
   * Removes the default actor element
   */


  function removeActor() {
    actor && actor.el && actor.el.remove();
  }
  /**
   *
   */


  function openDialog() {
    try {
      if (dialog) {
        dialog.open();
        isDialogOpen = true;

        if (options.onFormOpen) {
          options.onFormOpen();
        }

        handleOpenDialog();
        return;
      }

      var userKey = options.useSentryUser;
      var scope = getCurrentScope();
      var user = scope && scope.getUser();
      dialog = Dialog({
        colorScheme: options.colorScheme,
        showBranding: options.showBranding,
        showName: options.showName || options.isNameRequired,
        showEmail: options.showEmail || options.isEmailRequired,
        isNameRequired: options.isNameRequired,
        isEmailRequired: options.isEmailRequired,
        formTitle: options.formTitle,
        cancelButtonLabel: options.cancelButtonLabel,
        submitButtonLabel: options.submitButtonLabel,
        emailLabel: options.emailLabel,
        emailPlaceholder: options.emailPlaceholder,
        messageLabel: options.messageLabel,
        messagePlaceholder: options.messagePlaceholder,
        nameLabel: options.nameLabel,
        namePlaceholder: options.namePlaceholder,
        defaultName: userKey && user && user[userKey.name] || '',
        defaultEmail: userKey && user && user[userKey.email] || '',
        onClosed: function onClosed() {
          showActor();
          isDialogOpen = false;

          if (options.onFormClose) {
            options.onFormClose();
          }
        },
        onCancel: function onCancel() {
          closeDialog();
          showActor();
        },
        onSubmit: _handleFeedbackSubmit
      });

      if (!dialog.el) {
        throw new Error('Unable to open Feedback dialog');
      }

      shadow.appendChild(dialog.el); // Hides the default actor whenever dialog is opened

      hideActor();

      if (options.onFormOpen) {
        options.onFormOpen();
      }

      handleOpenDialog();
    } catch (err) {
      // TODO: Error handling?
      logger.error(err);
    }
  }
  /**
   * Closes the dialog
   */


  function closeDialog() {
    if (dialog) {
      dialog.close();
      isDialogOpen = false;

      if (options.onFormClose) {
        options.onFormClose();
      }
    }
  }
  /**
   * Removes the dialog element from DOM
   */


  function removeDialog() {
    if (dialog) {
      closeDialog();
      var dialogEl = dialog.el;
      dialogEl && dialogEl.remove();
      dialog = undefined;
    }
  }
  /**
   *
   */


  function handleActorClick() {
    // Open dialog
    if (!isDialogOpen) {
      openDialog();
    } // Hide actor button


    hideActor();
  }

  if (attachTo) {
    attachTo.addEventListener('click', handleActorClick);
  } else if (shouldCreateActor) {
    actor = Actor({
      buttonLabel: options.buttonLabel,
      onClick: handleActorClick
    });
    actor.el && shadow.appendChild(actor.el);
  }

  return {
    get actor() {
      return actor;
    },

    get dialog() {
      return dialog;
    },

    showActor: showActor,
    hideActor: hideActor,
    removeActor: removeActor,
    openDialog: openDialog,
    closeDialog: closeDialog,
    removeDialog: removeDialog
  };
}

var doc = WINDOW.document;

var feedbackIntegration = function feedbackIntegration(options) {
  // eslint-disable-next-line deprecation/deprecation
  return new Feedback(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */


var Feedback = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * Feedback configuration options
   */

  /**
   * Reference to widget element that is created when autoInject is true
   */

  /**
   * List of all widgets that are created from the integration
   */

  /**
   * Reference to the host element where widget is inserted
   */

  /**
   * Refernce to Shadow DOM root
   */

  /**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */
  function Feedback() {
    var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref16$autoInject = _ref16.autoInject,
        autoInject = _ref16$autoInject === void 0 ? true : _ref16$autoInject,
        _ref16$id = _ref16.id,
        id = _ref16$id === void 0 ? 'sentry-feedback' : _ref16$id,
        _ref16$isEmailRequire = _ref16.isEmailRequired,
        isEmailRequired = _ref16$isEmailRequire === void 0 ? false : _ref16$isEmailRequire,
        _ref16$isNameRequired = _ref16.isNameRequired,
        isNameRequired = _ref16$isNameRequired === void 0 ? false : _ref16$isNameRequired,
        _ref16$showBranding = _ref16.showBranding,
        showBranding = _ref16$showBranding === void 0 ? true : _ref16$showBranding,
        _ref16$showEmail = _ref16.showEmail,
        showEmail = _ref16$showEmail === void 0 ? true : _ref16$showEmail,
        _ref16$showName = _ref16.showName,
        showName = _ref16$showName === void 0 ? true : _ref16$showName,
        _ref16$useSentryUser = _ref16.useSentryUser,
        useSentryUser = _ref16$useSentryUser === void 0 ? {
      email: 'email',
      name: 'username'
    } : _ref16$useSentryUser,
        themeDark = _ref16.themeDark,
        themeLight = _ref16.themeLight,
        _ref16$colorScheme = _ref16.colorScheme,
        colorScheme = _ref16$colorScheme === void 0 ? 'system' : _ref16$colorScheme,
        _ref16$buttonLabel = _ref16.buttonLabel,
        buttonLabel = _ref16$buttonLabel === void 0 ? ACTOR_LABEL : _ref16$buttonLabel,
        _ref16$cancelButtonLa = _ref16.cancelButtonLabel,
        cancelButtonLabel = _ref16$cancelButtonLa === void 0 ? CANCEL_BUTTON_LABEL : _ref16$cancelButtonLa,
        _ref16$submitButtonLa = _ref16.submitButtonLabel,
        submitButtonLabel = _ref16$submitButtonLa === void 0 ? SUBMIT_BUTTON_LABEL : _ref16$submitButtonLa,
        _ref16$formTitle = _ref16.formTitle,
        formTitle = _ref16$formTitle === void 0 ? FORM_TITLE : _ref16$formTitle,
        _ref16$emailPlacehold = _ref16.emailPlaceholder,
        emailPlaceholder = _ref16$emailPlacehold === void 0 ? EMAIL_PLACEHOLDER : _ref16$emailPlacehold,
        _ref16$emailLabel = _ref16.emailLabel,
        emailLabel = _ref16$emailLabel === void 0 ? EMAIL_LABEL : _ref16$emailLabel,
        _ref16$messagePlaceho = _ref16.messagePlaceholder,
        messagePlaceholder = _ref16$messagePlaceho === void 0 ? MESSAGE_PLACEHOLDER : _ref16$messagePlaceho,
        _ref16$messageLabel = _ref16.messageLabel,
        messageLabel = _ref16$messageLabel === void 0 ? MESSAGE_LABEL : _ref16$messageLabel,
        _ref16$namePlaceholde = _ref16.namePlaceholder,
        namePlaceholder = _ref16$namePlaceholde === void 0 ? NAME_PLACEHOLDER : _ref16$namePlaceholde,
        _ref16$nameLabel = _ref16.nameLabel,
        nameLabel = _ref16$nameLabel === void 0 ? NAME_LABEL : _ref16$nameLabel,
        _ref16$successMessage = _ref16.successMessageText,
        successMessageText = _ref16$successMessage === void 0 ? SUCCESS_MESSAGE_TEXT : _ref16$successMessage,
        onFormClose = _ref16.onFormClose,
        onFormOpen = _ref16.onFormOpen,
        onSubmitError = _ref16.onSubmitError,
        onSubmitSuccess = _ref16.onSubmitSuccess;

    _classCallCheck(this, Feedback);

    // eslint-disable-next-line deprecation/deprecation
    this.name = Feedback.id; // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`

    this._host = null;
    this._shadow = null;
    this._widget = null;
    this._widgets = new Set();
    this._hasInsertedActorStyles = false;
    this.options = {
      autoInject: autoInject,
      showBranding: showBranding,
      id: id,
      isEmailRequired: isEmailRequired,
      isNameRequired: isNameRequired,
      showEmail: showEmail,
      showName: showName,
      useSentryUser: useSentryUser,
      colorScheme: colorScheme,
      themeDark: _objectSpread(_objectSpread({}, DEFAULT_THEME.dark), themeDark),
      themeLight: _objectSpread(_objectSpread({}, DEFAULT_THEME.light), themeLight),
      buttonLabel: buttonLabel,
      cancelButtonLabel: cancelButtonLabel,
      submitButtonLabel: submitButtonLabel,
      formTitle: formTitle,
      emailLabel: emailLabel,
      emailPlaceholder: emailPlaceholder,
      messageLabel: messageLabel,
      messagePlaceholder: messagePlaceholder,
      nameLabel: nameLabel,
      namePlaceholder: namePlaceholder,
      successMessageText: successMessageText,
      onFormClose: onFormClose,
      onFormOpen: onFormOpen,
      onSubmitError: onSubmitError,
      onSubmitSuccess: onSubmitSuccess
    };
  }
  /**
   * Setup and initialize feedback container
   */


  _createClass(Feedback, [{
    key: "setupOnce",
    value: function setupOnce() {
      if (!isBrowser()) {
        return;
      }

      try {
        this._cleanupWidgetIfExists();

        var autoInject = this.options.autoInject;

        if (!autoInject) {
          // Nothing to do here
          return;
        }

        this._createWidget(this.options);
      } catch (err) {
        DEBUG_BUILD && logger.error(err);
      }
    }
    /**
     * Allows user to open the dialog box. Creates a new widget if
     * `autoInject` was false, otherwise re-uses the default widget that was
     * created during initialization of the integration.
     */

  }, {
    key: "openDialog",
    value: function openDialog() {
      if (!this._widget) {
        this._createWidget(_objectSpread(_objectSpread({}, this.options), {}, {
          shouldCreateActor: false
        }));
      }

      if (!this._widget) {
        return;
      }

      this._widget.openDialog();
    }
    /**
     * Closes the dialog for the default widget, if it exists
     */

  }, {
    key: "closeDialog",
    value: function closeDialog() {
      if (!this._widget) {
        // Nothing to do if widget does not exist
        return;
      }

      this._widget.closeDialog();
    }
    /**
     * Adds click listener to attached element to open a feedback dialog
     */

  }, {
    key: "attachTo",
    value: function attachTo(el, optionOverrides) {
      var _this = this;

      try {
        var options = mergeOptions(this.options, optionOverrides || {});
        return this._ensureShadowHost(options, function (_ref17) {
          var shadow = _ref17.shadow;
          var targetEl = typeof el === 'string' ? doc.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;

          if (!targetEl) {
            DEBUG_BUILD && logger.error('[Feedback] Unable to attach to target element');
            return null;
          }

          var widget = createWidget({
            shadow: shadow,
            options: options,
            attachTo: targetEl
          });

          _this._widgets.add(widget);

          if (!_this._widget) {
            _this._widget = widget;
          }

          return widget;
        });
      } catch (err) {
        DEBUG_BUILD && logger.error(err);
        return null;
      }
    }
    /**
     * Creates a new widget. Accepts partial options to override any options passed to constructor.
     */

  }, {
    key: "createWidget",
    value: function createWidget(optionOverrides) {
      try {
        return this._createWidget(mergeOptions(this.options, optionOverrides || {}));
      } catch (err) {
        DEBUG_BUILD && logger.error(err);
        return null;
      }
    }
    /**
     * Removes a single widget
     */

  }, {
    key: "removeWidget",
    value: function removeWidget(widget) {
      if (!widget) {
        return false;
      }

      try {
        if (this._widgets.has(widget)) {
          widget.removeActor();
          widget.removeDialog();

          this._widgets.delete(widget);

          if (this._widget === widget) {
            // TODO: is more clean-up needed? e.g. call remove()
            this._widget = null;
          }

          return true;
        }
      } catch (err) {
        DEBUG_BUILD && logger.error(err);
      }

      return false;
    }
    /**
     * Returns the default (first-created) widget
     */

  }, {
    key: "getWidget",
    value: function getWidget() {
      return this._widget;
    }
    /**
     * Removes the Feedback integration (including host, shadow DOM, and all widgets)
     */

  }, {
    key: "remove",
    value: function remove() {
      if (this._host) {
        this._host.remove();
      }

      this._initialize();
    }
    /**
     * Initializes values of protected properties
     */

  }, {
    key: "_initialize",
    value: function _initialize() {
      this._host = null;
      this._shadow = null;
      this._widget = null;
      this._widgets = new Set();
      this._hasInsertedActorStyles = false;
    }
    /**
     * Clean-up the widget if it already exists in the DOM. This shouldn't happen
     * in prod, but can happen in development with hot module reloading.
     */

  }, {
    key: "_cleanupWidgetIfExists",
    value: function _cleanupWidgetIfExists() {
      if (this._host) {
        this.remove();
      }

      var existingFeedback = doc.querySelector("#".concat(this.options.id));

      if (existingFeedback) {
        existingFeedback.remove();
      }
    }
    /**
     * Creates a new widget, after ensuring shadow DOM exists
     */

  }, {
    key: "_createWidget",
    value: function _createWidget(options) {
      var _this2 = this;

      return this._ensureShadowHost(options, function (_ref18) {
        var shadow = _ref18.shadow;
        var widget = createWidget({
          shadow: shadow,
          options: options
        });

        if (!_this2._hasInsertedActorStyles && widget.actor) {
          shadow.appendChild(createActorStyles(doc));
          _this2._hasInsertedActorStyles = true;
        }

        _this2._widgets.add(widget);

        if (!_this2._widget) {
          _this2._widget = widget;
        }

        return widget;
      });
    }
    /**
     * Ensures that shadow DOM exists and is added to the DOM
     */

  }, {
    key: "_ensureShadowHost",
    value: function _ensureShadowHost(options, cb) {
      var needsAppendHost = false; // Don't create if it already exists

      if (!this._shadow || !this._host) {
        var id = options.id,
            colorScheme = options.colorScheme,
            themeLight = options.themeLight,
            themeDark = options.themeDark;

        var _createShadowHost = createShadowHost({
          id: id,
          colorScheme: colorScheme,
          themeLight: themeLight,
          themeDark: themeDark
        }),
            shadow = _createShadowHost.shadow,
            host = _createShadowHost.host;

        this._shadow = shadow;
        this._host = host;
        needsAppendHost = true;
      } // set data attribute on host for different themes


      this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
      var result = cb({
        shadow: this._shadow,
        host: this._host
      });

      if (needsAppendHost) {
        doc.body.appendChild(this._host);
      }

      return result;
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Feedback';
    }
  }]);

  return Feedback;
}();

Feedback.__initStatic();

export { Feedback, feedbackIntegration, sendFeedback };